function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgGames = function SvgGames(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.438c-3.02 0-6.213.3-7.616.566H4.38a.637.637 0 00-.459.335v.001c-.587 1.14-1.083 2.91-1.428 4.683-.345 1.768-.527 3.48-.511 4.484.017 1.008.392 1.764.958 2.269.57.508 1.373.793 2.302.786 1.017-.007 1.723-.687 2.276-1.669.271-.483.487-1.007.672-1.496l.15-.406c.12-.327.233-.634.337-.859a.491.491 0 01.448-.278h5.752c.194 0 .37.109.448.278.104.225.216.53.336.856.05.134.1.272.152.409.185.49.401 1.013.673 1.496.553.982 1.26 1.662 2.274 1.67.93.006 1.731-.28 2.302-.787.566-.505.94-1.261.958-2.27.016-1.004-.166-2.714-.51-4.482-.346-1.771-.842-3.541-1.428-4.684l-.001-.001a.649.649 0 00-.464-.335c-1.405-.262-4.598-.566-7.616-.566zm-7.804-.354C5.68 4.802 8.938 4.5 12 4.5c3.064 0 6.324.308 7.805.584h.003c.5.097.927.401 1.152.843.647 1.26 1.162 3.132 1.511 4.926.35 1.798.546 3.577.528 4.669-.022 1.234-.488 2.243-1.27 2.94-.78.693-1.834 1.045-2.977 1.038-1.569-.011-2.527-1.092-3.13-2.162a11.896 11.896 0 01-.732-1.622c-.062-.166-.12-.32-.171-.462a23.976 23.976 0 00-.174-.463h-5.09c-.038.082.04-.104 0 0-.054.136-.11.291-.174.464l-.17.46c-.19.503-.425 1.078-.731 1.622-.603 1.071-1.56 2.152-3.132 2.163-1.143.007-2.198-.345-2.976-1.038-.783-.697-1.25-1.705-1.27-2.94-.019-1.092.176-2.872.526-4.67.35-1.796.865-3.668 1.512-4.926v.002a1.612 1.612 0 011.156-.844z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.287 7.18c.27 0 .49.21.49.47v3.535a.48.48 0 01-.49.468.48.48 0 01-.49-.468V7.65a.48.48 0 01.49-.47z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91 9.417a.48.48 0 01.49-.469h3.773c.27 0 .49.21.49.47a.48.48 0 01-.49.468H5.4a.48.48 0 01-.49-.469z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM19.5 8.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: props.color
  }));
};
SvgGames.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgGames.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgGames;